import axios from "axios";
import { API_BASE_URL } from "../../config";

const BASE = API_BASE_URL.endsWith("/api") ? API_BASE_URL : `${API_BASE_URL}/api`;

/** Fetch Aging Report – summary by aging buckets */
export const getAgingReport = async (period = null) => {
  const url = period ? `${BASE}/reports/aging?period=${period}` : `${BASE}/reports/aging`;
  const response = await axios.get(url);
  return response.data;
};

